import { Component } from '@angular/core';
import { ContractModelService } from '../contracts.model.service';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.payments.component.html',
  providers: []
})

export class ContractsPaymentsComponent {

  model: any = {};
  errorMessage: string;

  constructor(private contractModelService: ContractModelService) {
  }

  ngOnInit() {
    this.model = this.contractModelService.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/payments/contracts.payment.component.ts